"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (dateValue) {
    return new Date(dateValue).toLocaleDateString("en-GB", {
        timeZone: "UTC"
    });
});
